import { Predicate } from "@siteimprove/alfa-predicate";
const { equals } = Predicate;
export function hasName(nameOrPredicate, ...names) {
    let predicate;
    if (typeof nameOrPredicate === "function") {
        predicate = nameOrPredicate;
    }
    else {
        predicate = equals(nameOrPredicate, ...names);
    }
    return (role) => predicate(role.name);
}
//# sourceMappingURL=has-name.js.map